import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import OrderDashboardLayout from "./Layout/OrderDashboardLayout.jsx";
import PnoInTimeGraph from "./TablesAndGraphs/ByFilter/PnoInTimeGraph.jsx";
import OrdersInTimeGraph from "./TablesAndGraphs/ByFilter/OrdersInTimeGraph.jsx";
import PnoPanel from "./TablesAndGraphs/ByFilter/PnoPanel.jsx";
import * as PropTypes from "prop-types";
import ChannelGrid from "../MarketingChannelGrids/ChannelGrid.jsx";
import {GridType} from "../MarketingChannelGrids/channelGridColumnSetup.js";

export default function OrderMarketingChannelOverview({project}) {

    let {t} = useTranslation();

    let [topGraphsHidden, setTopGraphsHidden] = useState(true);

    // noinspection JSValidateTypes
    return <OrderDashboardLayout title={t('route.campaign-performance')} showMarketingFilters={true}>

        <PnoInTimeGraph
            project={project}
            defaultHidden={true}
            hidden={topGraphsHidden}
            setHidden={setTopGraphsHidden}
            showHideButton={true}
        />

        <OrdersInTimeGraph
            project={project}
            defaultHidden={true}
            hidden={topGraphsHidden}
            setHidden={setTopGraphsHidden}
            showHideButton={true}
        />

        <PnoPanel project={project} halfSize={true} />
        <ChannelGrid project={project} gridType={GridType.MarketingOrders}/>
    </OrderDashboardLayout>;
}
